import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CasesList from './pages/CasesList';
import CaseDetail from './pages/CaseDetail';
import Inbox from './pages/Inbox';
import Referrers from './pages/Referrers';
import Team from './pages/Team';
import NewCase from './pages/NewCase';
import Layout from './components/Layout';

function PrivateRoute({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return <div style={{padding: 40, textAlign: 'center', color: '#888'}}>Chargement...</div>;
  if (!admin) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { admin, loading } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={!loading && admin ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/cases" element={<PrivateRoute><CasesList /></PrivateRoute>} />
      <Route path="/cases/new" element={<PrivateRoute><NewCase /></PrivateRoute>} />
      <Route path="/cases/:id" element={<PrivateRoute><CaseDetail /></PrivateRoute>} />
      <Route path="/inbox" element={<PrivateRoute><Inbox /></PrivateRoute>} />
      <Route path="/referrers" element={<PrivateRoute><Referrers /></PrivateRoute>} />
      <Route path="/team" element={<PrivateRoute><Team /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
